/*
 * @Author: lbh
 * @Date: 2020-12-24 18:12:01
 * @LastEditors: lbh
 * @LastEditTime: 2025-06-27 09:43:45
 * @Description: 路由
 */
import Vue from "vue";
// 引入 路由依賴
import Router from "vue-router";
import logan from "@/js/util/logan";
import store from "@/store";

const extCallNumber = () => import("./extCallNumber").then((m) => m.default);
const appRouter = () => import("./appRouter").then((m) => m.default);

const brandRouter = () => import("./brand").then((m) => m.default);
const codeRouter = () => import("./code").then((m) => m.default);

const activitiesRouter = () => import("./activities").then((m) => m.default);

import orderRouter from "./order";

// * 登錄頁
import loginRouter from "./login";

import testRouter from "./test";

const finalTestRouter =
  process.env.NODE_ENV !== "development" ? [] : testRouter;

// 使用路由依賴
Vue.use(Router);

const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
/**
 * 定義路由
 * 使用 component 達到 懶加載 目的. 加快首次打開的速度
 */

let router = new Router({
  mode: "history", //去掉url中的#
  base: "/shop",
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置，则恢复该位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则，滚动到顶部
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: "pcBrand",
      component: () => import("@/views/menu/brand"), // pc 的餐廳列表
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "*",
      name: "error",
      component: () => import("@/views/error/error"), // 錯誤頁面
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pcPay/:arg",
      name: "pcPay",
      component: () => import("@/views/pc/pcPay"), // pc支付頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pcInviteCode/:arg",
      name: "pcInviteCode",
      component: () => import("@/views/pc/pcInviteCode"), // 自取取餐碼
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/test",
      name: "test",
      component: () => import("@/views/error/test"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/shop/:arg",
      name: "shop",
      component: () => import("@/views/restaurant/shop_.vue"), // 餐廳專屬頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/shop2/:arg",
      name: "shop2",
      component: () => import("@/views/restaurant/shop.vue"), // 餐廳專屬頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/restaurantList/:arg",
      name: "restaurantList",
      component: () => import("@/views/restaurant/list"), // 餐廳列表
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/addressList/:arg",
      name: "addressList",
      component: () => import("@/views/address/list"), // 地址列表
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/addressAdd/:arg",
      name: "addressAdd",
      component: () => import("@/views/address/add"), // 添加/修改地址
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/map",
      name: "map",
      component: () => import("@/views/address/map"), // 地圖頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/index/:arg",
      name: "index",
      component: () => import("@/views/restaurant/index/index.vue"), // 餐牌頁
      meta: {
        keepAlive: false,
        name: "diancan",
      },
    },
    {
      path: "/kioskIndex/:arg",
      name: "kioskIndex",
      component: () => import("@/views/restaurant/index/index.vue"), // 餐牌頁
      meta: {
        keepAlive: true,
        name: "点餐机点餐",
      },
    },
    {
      path: "/index2/:arg",
      name: "index2",
      component: () => import("@/views/restaurant/menu/index"), // 餐牌頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/combo/:arg",
      name: "combo",
      component: () => import("@/views/restaurant/combo"), // 套餐與細項
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/deliveryOrder/:arg?",
      name: "deliveryOrder",
      component: () => import("@/views/order/deliveryOrder"), // 外送送單頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/scanOrder/:arg",
      name: "scanOrder",
      component: () => import("@/views/order/scanOrder"), // 掃碼點餐 送單
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/coupon/:arg",
      name: "coupon",
      component: () => import("@/views/order/coupon"), // 我的優惠券
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pcCoupon/:arg",
      name: "pcCoupon",
      component: () => import("@/views/pc/pcCoupon"), // pc 我的優惠券
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/remark",
      name: "remark",
      component: () => import("@/views/order/remark"), // 備註
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pay/:arg",
      name: "pay",
      component: () => import("@/views/order/pay"), // 支付頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/orderDetail/:arg",
      name: "orderDetail",
      component: () => import("@/views/order/orderDetail"), // 訂單詳情
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/myOrder/:arg",
      name: "myOrder",
      component: () => import("@/views/order/myOrder"), // 我的訂單
      meta: {
        keepAlive: false,
        name: "dingdan",
      },
    },
    {
      path: "/inviteOrder/:arg?",
      name: "inviteOrder",
      component: () => import("@/views/order/inviteOrder"), // 自取送單
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/inviteCode/:arg",
      name: "inviteCode",
      component: () => import("@/views/order/inviteCode"), // 自取取餐碼
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/scanCode/:arg",
      name: "scanCode",
      component: () => import("@/views/restaurant/scanCode"), // 預點餐頁面
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/foodDetail",
      name: "foodDetail",
      component: () => import("@/views/gsa/food_detail"), // 雲端gsa 食品詳情頁
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/collectCoupons/:arg",
      name: "collectCoupons",
      component: () => import("@/views/activities/collectCoupons"), // 活動領券頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/collect/:arg",
      name: "collect",
      component: () => import("@/views/activities/collect"), // 活動領券頁 - 公共頁面
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/whatsAppTakeCoupon/:arg",
      name: "whatsAppTakeCoupon",
      component: () => import("@/views/activities/whatsAppTakeCoupon"), // WhatsApp 活動領券頁 - 公共頁面
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/restaurantMap",
      name: "restaurantMap",
      component: () => import("@/views/address/restaurantMap"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/collect/couponList/:arg",
      name: "collectCouponList",
      component: () => import("@/views/activities/couponList"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/collect/couponDetail/:arg",
      name: "collectCouponDetail",
      component: () => import("@/views/activities/couponDetail"),
      meta: {
        keepAlive: false,
      },
    },

    // pc 部分
    {
      path: "/pcInviteOrder",
      name: "pcInviteOrder",
      component: () => import("@/views/pc/inviteOrder"), // 自取送單
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pcDeliveryOrder",
      name: "pcDeliveryOrder",
      component: () => import("@/views/pc/inviteOrder"), // 外送送單
      meta: {
        keepAlive: false,
      },
    },
    // pc 適配
    {
      path: "/pcIndex/:arg",
      name: "pcIndex",
      component: () => import("@/views/pc/index"), // 餐牌頁
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pcOrderDetail/:arg",
      name: "pcOrderDetail",
      component: () => import("@/views/pc/orderDetail"), // 訂單詳情
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/printing/:arg",
      name: "printing",
      component: () => import("@/views/activities/printing.vue"), // 印花
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/printingDetail/:arg",
      name: "printingDetail",
      component: () => import("@/views/activities/printingDetail.vue"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/fixedPayOrder/:arg",
      name: "fixedPayOrder",
      component: () => import("@/views/order/fixedPayOrder"), // 掃碼點餐 送單
      meta: {
        keepAlive: false,
      },
    },
    // 套票
    {
      path: "/conponGroupList/:arg?",
      name: "conponGroupList",
      component: () => import("@/views/activities/couponGroupList"),
      meta: {
        keepAlive: false,
      },
    },
    // 優惠券列表
    {
      path: "/myCoupons/:arg",
      name: "myCoupons",
      component: () => import("@/views/activities/coupon_list"),
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/sendSingle/:arg",
      name: "sendSingle",
      component: () => import("@/views/pc/sendSingle"), // pc送单列表
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pcAddressList/:arg",
      name: "pcAddressList",
      component: () => import("@/views/pc/pcAddressList"), // pc 地址列表
      meta: {
        keepAlive: false,
      },
    },

    //叫號
    {
      path: "/callNumber/:arg?",
      name: "callNumber",
      component: () => import("@/views/callNumber/index"),
      meta: {
        keepAlive: false,
      },
    },
    //叫號詳情
    {
      path: "/callNumberDetail/:arg?",
      name: "callNumberDetail",
      component: () => import("@/views/callNumber/callNumberDetail"),
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/autoCodeOrderDetail/:arg",
      name: "autoCodeOrderDetail",
      component: () => import("@/views/order/autoCodeOrderDetail"), // 訂單詳情
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/announce/index/:arg?",
      name: "announce/index",
      component: () => import("@/views/announce/index"), // 訂單詳情
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/announce/detail/:arg?",
      name: "announce/detail",
      component: () => import("@/views/announce/detail"), // 訂單詳情
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/locationMap/:arg",
      name: "locationMap",
      component: () => import("@/views/callNumber/mapShow"), // 地圖
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/callNumberAd/:arg",
      name: "callNumberAd",
      component: () => import("@/views/callNumber/callNumberAd"), // 叫號廣告
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/swiperTest",
      name: "swiperTest",
      component: () => import("@/views/test/index"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/moreCoupon/:arg",
      name: "moreCoupon",
      component: () => import("@/views/activities/moreCoupon"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/collection/:arg",
      name: "collection",
      component: () => import("@/views/me/collection"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/couponOrderDetail/:arg?",
      name: "couponOrderDetail",
      component: () => import("@/views/order/couponOrderDetail.vue"),
    },
    {
      path: "/callNumberHistory/:arg?",
      name: "callNumberHistory",
      component: () => import("@/views/callNumber/history.vue"),
    },
    {
      path: "/changeLang",
      name: "changeLang",
      component: () => import("@/views/i18n/changeLang.vue"),
    },
    {
      path: "/myCouponList/:arg?",
      name: "myCouponList",
      component: () => import("@/views/activities/myCouponList.vue"),
    },
    {
      path: "/resource/:arg?",
      name: "resource",
      component: () => import("@/views/resource/index.vue"),
    },
    // * kiosk 送单
    {
      path: "/kioskOrder/:arg",
      name: "kioskOrder",
      component: () => import("@/views/order/kioskOrder"), // 掃碼點餐 送單
      meta: {
        keepAlive: false,
      },
    },
    // 动态导入其他路由模块
    ...(await extCallNumber()),
    ...(await appRouter()),
    ...(await brandRouter()),
    ...(await codeRouter()),
    ...(await activitiesRouter()),
    ...finalTestRouter,
    ...loginRouter,
    ...orderRouter,
  ],
});

// * 獲取 params 參數 | 適用於 vue2
router.getParams = () => {
  let params = router.currentRoute.params || {};
  let arg = params?.arg || "";
  if (arg) {
    let pageParams = window.atob(arg.replace(/Rp8/g, "="));
    if (pageParams) return pageParams.split("_");
    return [];
  }
  return [];
};

// * 前往頁面
router.goPage = (name, params, query) => {
  if (Array.isArray(params)) params = params.join("_");
  let pageParams = window.btoa(params).replace(/=/g, "Rp8");
  let path = {
    name: name,
  };
  if (pageParams) path.params = { arg: pageParams };
  if (query && typeof query === "object") path.query = query;
  router.push(path);
};

// 路由攔截
router.beforeEach((to, from, next) => {
  // * 新路由先隔離上一頁品牌，返回快取頁則恢復該頁已確認的品牌
  if (to.path !== from.path) store.commit("activateBrandRoute", to.path);
  logan.log(`${to.name}->${from.name}`, logan.types.go);
  next();
});
router.tab = function (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

export default router;
